<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-40"
      :bodyStyle="{ paddingTop: '12px' }"
    >
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6>History of check-in Smart Authen</h6>
            <p class="mb-10"></p>
          </a-col>
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="text-right">
            <a-button type="primary" size="small" @click="genExcelDataStdList">
              <a-icon type="download"></a-icon>Download to Excel
            </a-button>
          </a-col>
        </a-row>
      </template>
      <a-table
        class="mb-20"
        :columns="columnsEvent"
        :data-source="dataCheckinEvent"
        :pagination="false"
        :loading="loadingA"
        bordered
        size="small"
      >
        <template slot="date" slot-scope="text, record">
          {{ moment(record.created_at).locale('th').add(543, 'years').format("DD MMMM YYYY") }}
        </template>
        <template slot="time" slot-scope="text, record">
          {{ moment(record.created_at).format("LTS") }}
        </template>
        <template slot="type" slot-scope="text, record">
          <a-badge
            class="text-capitalize"
            :count="record.event_detail.event_type.toString().toUpperCase()"
            :number-style="{
              backgroundColor: colorEvent[`${record.event_detail.event_type}`],
            }"
          />
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<style scoped>
.mb-20 >>> .ant-table-thead > tr > th {
  background-color: #000000 !important;
  color: #ffffff !important;
  font-weight: bold !important;
  text-align: center !important;
  font-size: 1.1em !important;
}
</style>

<script>
const mainExcel = ["A", "B", "C", "D", "E"];
const reportA = [
  {
    A: "Date",
    B: "Time stamp",
    C: "Event name",
    D: "Event Type",
    E: "Remark",
  },
];
const columnsEvent = [
  {
    title: "Date",
    dataIndex: "date",
    scopedSlots: { customRender: "date" },
  },
  {
    title: "Time stamp",
    dataIndex: "time",
    scopedSlots: { customRender: "time" },
  },
  {
    title: "Event name",
    dataIndex: "event_detail.name",
    scopedSlots: { customRender: "event_detail.name" },
    width: "30%",
  },
  {
    title: "Event Type",
    dataIndex: "type",
    scopedSlots: { customRender: "type" },
  },
  // {
  //   title: "Remark",
  //   dataIndex: "event_detail.remark",
  //   scopedSlots: { customRender: "event_detail.remark" },
];
export default {
  data() {
    return {
      columnsEvent,
      dataCheckinEvent: [],
      loadingA: false,
      colorEvent: {
        meeting: "#58287F",
        general: "#89C4E1",
        borrow: "#E1D7C6",
        learn: "#FD8A8A",
        other: "#DFD3C3",
      },
      dataReportExcel: [],
      btnExportLoading: false,
      mainExcel,
      reportA,
    };
  },
  mounted() {
    this.getListSmartAuthen();
  },
  methods: {
    async getListSmartAuthen() {
      this.loadingA = true;
      this.dataCheckinEvent = [];
      this.dataReportExcel = [];
      try {
        const res = await this.$http.get(`/smart-authen/check-in/me/`);
        if (res.status === 200) {
          // render table
          this.dataCheckinEvent = res.data.check_in_history.map((item) => ({ ...item }));
          // excel report
          this.dataReportExcel = res.data.check_in_history.map((report) => ({
            A: `${this.moment(report.created_at).locale('th').add(543, 'years').format("DD MMMM YYYY")}`,
            B: `${this.moment(report.created_at).format("LTS")}`,
            C: report.event_detail.name,
            D: `${report.event_detail.event_type.toString().toUpperCase()}`,
            E: report.event_detail.remark,
          }));
          // sort
          this.dataCheckinEvent.sort((a, b) => {
            return b.id - a.id;
          });
          this.loadingA = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataCheckinEvent = [];
        this.loadingA = false;
        this.$notification.open({
          style: {
            backgroundColor: `#ff1919`,
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /smart-authen/check-in/me/`,
        });
      }
    },
    async genExcelDataStdList() {
      this.btnExportLoading = true;
      const SummaryWS = this.XLSX.utils.json_to_sheet(
        this.reportA.concat(this.dataReportExcel),
        {
          header: this.mainExcel,
          skipHeader: true,
        }
      );
      const wb = this.XLSX.utils.book_new();
      this.XLSX.utils.book_append_sheet(wb, SummaryWS, "smart-authen-log");
      this.XLSX.writeFile(wb, "smart_authen_log.xlsx");
      this.btnExportLoading = false;
    },
  },
};
</script>